module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epigraphPage_01"
    }
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('span', [_vm._v("The voice of thy brother’s blood crieth unto me"), _c('br'), _vm._v("\nfrom the ground…")])]), _c('p', {
    staticClass: "epigraphSource"
  }, [_c('span', [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENESIS")]), _vm._v(" 4:10")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8ec436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780743299084_epigraphPage_01.vue
// module id = 69
// module chunks = 0